import axios from "axios";

export enum IntegrationId {
  Patreon = "patreon",
}

export enum IntegrationType {
  Oauth = "oauth",
}

export interface IntegrationSchema {
  id: IntegrationId;
  type: IntegrationType;
  label: string;
}

export enum IntegrationStatus {
  Connecting = "connecting",
  Connected = "connected",
  Failed = "failed",
}

export interface Integration {
  id: number;
  kind: IntegrationId;
  status: IntegrationStatus;
}

export const getWorkspaceIntegrations = async (
  workspaceId: number,
): Promise<{ schema: IntegrationSchema[]; integrations: Integration[] }> => {
  return (await axios.get(`/api/v1/workspaces/${workspaceId}/integrations`))
    .data;
};

export const connectWorkspaceIntegration = async (
  workspaceId: number,
  integrationId: IntegrationId,
  context?: Record<string, any>,
): Promise<{ "oauth-url"?: string }> => {
  return (
    await axios.post(`/api/v1/workspaces/${workspaceId}/integrations`, {
      id: integrationId,
      context,
    })
  ).data;
};

export const disconnectWorkspaceIntegration = async (
  workspaceId: number,
  integrationId: IntegrationId,
): Promise<void> => {
  await axios.delete(
    `/api/v1/workspaces/${workspaceId}/integrations/${integrationId}`,
  );
};
